if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      let selling_plan_id = null;
      if (this.form.querySelector('[name="selling_plan"]')) {
        selling_plan_id = this.form.querySelector('[name="selling_plan"]').value;
      } else if (document.querySelector(`[name="selling_plan"][form="${ this.form.getAttribute('id') }"]`)) {
        selling_plan_id = document.querySelector(`[name="selling_plan"][form="${ this.form.getAttribute('id') }"]`).value;
      }

      let discount = null;
      let discountVal = 0;
      if (this.form.querySelector('[name="properties[Discount]"]')) {
        discount = this.form.querySelector('[name="properties[Discount]"]').value;
      } else if (document.querySelector(`[name="properties[Discount]"][form="${ this.form.getAttribute('id') }"]`)) {
        discount = document.querySelector(`[name="properties[Discount]"][form="${ this.form.getAttribute('id') }"]`).value;
      }
      if (discount) {
        discountVal = Number(discount.replace(/[^0-9\.]+/g,""));
      }
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          if (discountVal > 0) {
            this.submitExtraItems({'id': selling_plan_id, 'discount': discount});
          } else {
            this.submitExtraItems({'id': selling_plan_id});
          }
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }

    submitExtraItems(selling_plan_data = null) {
      const el = this;
      let extraItems = this.extraItems();
      if (selling_plan_data) {
        extraItems.forEach((item) => {
          item['selling_plan'] = selling_plan_data['id'];
          if (item['properties']) {
            item['properties']['Discount'] = selling_plan_data['discount'];
          } else {
            item['properties'] = {'Discount': selling_plan_data['discount']};
          }
        })
      }
      if(extraItems.length > 0) {
        let formData = {"items": extraItems};
        if (this.cart) {
          formData.sections = this.cart.getSectionsToRender().map((section) => section.id);
          formData.sections_url = window.location.pathname;
          this.cart.setActiveElement(document.activeElement);
        }
        fetch('/cart/add.js', { method: 'POST', headers: {'Content-Type': 'application/json'}, body:  JSON.stringify(formData)})
        .then(response => response.json())
        .then(response => { if (!response.status) { el.cart.renderContents(response); }});
      }
    }

    extraItems() {
      let extraItems = [];
      let extraVariantsId = [];
      let extraItemsContainer = document.querySelector('[data-quantity-option]:checked');
      const extraSubItemsContainer = document.querySelector('[data-sub-quantity-option]:checked');
      if (extraSubItemsContainer) {
        if (extraSubItemsContainer.classList.contains("td-active")) {
          extraItemsContainer = extraSubItemsContainer;
        }
      }
      if (extraItemsContainer) {
        let extraVariants;
        if (extraItemsContainer.hasAttribute("data-skio-quantity")) {
          extraVariants = document.querySelectorAll("[data-skio-quantity-option-variant]:checked");
          extraVariants.forEach((v, index) => {
            let loopIndex = index + 1;
            if(loopIndex < extraItemsContainer.value){ extraVariantsId.push(v.value) }
          });
        } else {
          extraVariants = document.querySelectorAll(`[data-quantity-option-variant="${extraItemsContainer.id}"]:checked`);
          extraVariants.forEach((v) => extraVariantsId.push(v.value));
        }
        if(extraVariantsId.length > 0) {
          let vAdded = [];
          extraItems = extraVariantsId.reduce(function(result, v) {
            if (!vAdded.includes(v)){
              let qty = 0;
              extraVariantsId.forEach((item) => {
                if(item == v){ qty = qty + 1; }
              });
              vAdded.push(v);
              result.push({ "id": parseInt(v), "quantity": qty });
            }
            return result;
          }, []);
        }
      }
      return extraItems;
    }
    
  });
}
